import * as api from "../Api/index";
import toast from "react-hot-toast";
export const sendApproverEmail = (postData) => async (dispatch) => {
  let sendingId;
  try {
    sendingId = toast.loading("Sending email...");
    await api.sendVerificationCode(postData);
    toast.remove(sendingId);
    toast.success("Email sent successfully");
    const message =
      "Please check your email, an approver code has been sent to you. enter it in the text field below";
    dispatch({ type: "SEND_APPROVER_VERIFICATION_CODE", payload: message });
  } catch (error) {
    toast.remove(sendingId);
    toast.error(error.message);
  }
};
export const verifyUser = (code) => async (dispatch) => {
  let verifyingId;
  try {
    verifyingId = toast.loading("verifying...");
    const { data } = await api.verifyCode(code);
    toast.remove(verifyingId);
    toast.success("successfully verified");
    const message = "Verified";
    dispatch({
      type: "CHECK_APPROVER_VERIFICATION_CODE",
      payload: message,
      data: data,
    });
  } catch (error) {
    toast.remove(verifyingId);
    const errorMessage = error.response.data.message;
    toast.error(errorMessage || error.message);

    dispatch({
      type: "CHECK_APPROVER_VERIFICATION_CODE_ERROR",
      payload: errorMessage,
    });
  }
};
